const parser = new DOMParser()

export function htmlToElement<T extends Element = HTMLElement>(html: string): T {
    return parser.parseFromString(html, "text/html").body.firstElementChild as T
}
